export default __webpack_public_path__ + "static/media/mier-y-pesado.cd1addb1.svg";